<template lang="pug">
  v-row
    v-col.py-0(cols="12")
      v-row.flex-nowrap(align="center")
        v-col.flex-shrink-1.py-0(v-if="onlySelect", cols="4")
          g-text-field(v-model="name", label="Column name")
        v-col.flex-shrink-1.py-0(:cols="!onlySelect ? 3 : 8")
          app-entity-path-selector(
            v-show="operator != 'custom expression'",
            ref="path-selector",
            :entity="criteriaEntity",
            @path="path = $event.path; field = $event.field",
            :title="$t('Common.select')",
            :disabled="disabled"
          )
        v-col(v-if="onlySelect")
          g-btn.h7.mb-2(
            height="40"
            color="primary",
            @click="$emit('add', { text: name, value: path, type: type }); reset();", 
          )
            v-icon.mr-1(style="font-size: 16px") mdi-plus-circle
            | {{$t('Common.add')}}
        v-col.flex-shrink-1.py-0(cols="2", align-self="end" v-if="!onlySelect")
          g-select(
            :items="operators",
            v-model="operator",
            :disabled="disabled"
          )
        v-col.flex-shrink-1.py-0(cols="7", align-self="end" v-if="!onlySelect")
          foo-field(
            v-if="field && operator != 'custom expression'",
            :type="type",
            @keydown.enter="pushCriteria",
            :value="value",
            @input="handleInput",
            rounded,
            outlined,
            placeholder="Type here",
          )
          slot(v-else)
            v-text-field(
              v-if="operator == 'custom expression'",
              @keydown.enter="pushCriteria",
              v-model="value"
            )
        v-col.py-0(v-if="!onlySelect")
          v-btn.mb-2(
            elevation="0",
            color="grey lighten-2",
            :style="{ visibility: path || operator == 'custom expression' ? 'visible' : 'hidden' }",
            fab,
            small
          )
            v-icon(@click="reset", color="grey") mdi-close
    v-col(cols="12", v-if="!onlySelect && (criterias.length > 0)")
      g-chip.mx-1.mb-2(
        @click:close="criterias.splice(i, 1); notify(c)", 
        v-for="(c, i) in splittedCriteria",
        color="primary",
        outlined,
      )
        //- splittedCriteria elements always return 3 elements
        .inner-text.d-flex.chip-text-style 
          span.d-flex {{ c[0]}}
            span.grey--text(:class="c[2] == '' ? 'text--darken-3' : 'darken-3--text'") {{ c[1] }}
          | {{ c[2] }}
  
  </template>
  
<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: {
    parent: Object,
    entity: Object,
    criteriaEntityName: String,
    onlySelect: Boolean,
    initialCriterias: Array
  },
  data() {
    return {
      name: '',
      value: null,
      criterias: [...(this.initialCriterias || [])],
      operator: 'Contains',
      path: null,
      field: null
    }
  },
  methods: {
    handleInput($event) {
      this.value = $event;
      if (this.type === 'DateTime') this.pushCriteria();
    },
    pushCriteria() {
      this.criterias.push({ value: this.criteria, label: this.criteria })
      this.notify();
      this.reset();
    },
    reset() {
      this.$refs['path-selector'].reset()
      this.name = ''
      this.path = null
      this.field = null
      this.value = null
      this.operator = '='
    },
    notify(criteria) {
      let indexCrit = _.findIndex(this.initialCriterias || [], c => c && criteria && c.value === criteria.value);
      if (indexCrit != -1) {
        const copyInitial = [...this.initialCriterias];
        copyInitial.splice(indexCrit, 1);
        this.$emit('changeInitial', copyInitial);
      }
      this.$emit('criteria', criteria || this.criteria)
    },
    tagType(label, c) {
      if (!label) return 'none';
      if (label.includes('.Contains(')) {
        return 'contains'
      }
      return 'custom'
    }
  },
  computed: {
    splittedCriteria() {
      // this reduction splits the parts of the criteria, it should always be 3 parts, see DOM where this is used
      return this.criterias.reduce((allParts, criteria) => {
        let parts = [];
        if (!criteria.label)
          parts = ['', '', '', '']; // first element will be removed since in matches (that we are acumulating) the first element is the whole match and we need the group matches
        if (criteria.label.includes('.Contains('))
          parts = (/([\S\s]*.Contains\()([\S\s]*)(\))/).exec(criteria.label);
        else {
          parts = (/([\S\s]*)("[\S\s]*")*/).exec(criteria.label);
          parts.push(''); // to complete 3 elements to return
        }
        parts.shift(); // removes group 0 (all match)
        allParts.push(parts); //return all parts
        return allParts;
      }, []);
    },
    operators() {
      return [
        { text: '=', value: '=' },
        { text: '>=', value: '>=' },
        { text: '<=', value: '<=' },
        { text: '!=', value: '!=' },
        { text: this.$t('Criteria.optionContains'), value: 'Contains' },
        { text: this.$t('Criteria.optionCustomExpression'), value: 'custom expression' },
      ];
    },

    criteriaEntityEnvName() {
      return this.criteriaEntityName ||
        (this.parent &&
          ENV.ENTITIES[this.parent.name] &&
          ENV.ENTITIES[this.parent.name].entityForCriteria)
    },
    criteriaEntity() {
      return this.$findEntity(this.criteriaEntityEnvName) || this.entity
    },
    type() {
      return this.field
        ? this.field.type === 'Guid'
          ? 'String'
          : this.field.type
        : undefined
    },
    criteria() {
      if (this.operator === 'custom expression')
        return this.value
      if (this.operator === 'Contains' && this.field.type === 'String')
        return `${this.path}.Contains(${this.escapedValue})`
      return `${this.path} ${this.operator} ${this.escapedValue}`
    },
    escapedValue() {
      if (this.value.startsWith("\"") && this.value.endsWith("\""))
        return this.value
      return this.value = (this.type === "String" || this.type === "DateTime") ? `"${this.value}"` : this.value
    }
  }
}
</script>

<style>
.chip-text-style {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>